.fx{border:1px solid #ddd;}